import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class InteractionService {
  hitaddvalue = new Subject();
  backArrowPage = new Subject();
  backArrowPageForTransaction = new Subject();
  backArrowForOrg = new Subject();
  myGlobalVar: any = '';
  contriesList = [];
  selectedCountry: string = '';
  hamburger: boolean;
  showDetails: boolean;
  private nspFlagAdmin: string | undefined;

  private _headerTitle = new Subject<string>();

  private _country = new Subject<string>();
  private _multiFee = new Subject<string>();
  private _org = new Subject<string>();
  private _orgName = new Subject<any>();
  private _object = new Subject<any>();
  private _showNSPPrinciple = new Subject<boolean>();
  private _hamburger = new Subject<any>();

  private _showDetails = new Subject<any>();

  private _settingoption = new Subject<any>();
  private _orgNum = new Subject<any>();
  private _multiFeeFlagForPartner = new Subject<any>();
  private changeOrg = new Subject<any>();
  private _orgNameForCustomeFilter = new Subject<any>();
  nspFlagPartner: any;
  sList: any[] = [];
  private _orgCodeForCustomFilter = new Subject<any>();
  private _setPageId = new Subject<any>();

  // NEW: Clean organization change mechanism
  private _currentOrganization = new BehaviorSubject<any>(null);
  public currentOrganization$ = this._currentOrganization.asObservable();

  // NEW: Specific subject for organization switches from dropdown
  private _organizationSwitch = new Subject<any>();
  public organizationSwitch$ = this._organizationSwitch.asObservable();

  // NEW: Organization change event for components that need to react to changes
  private _organizationChanged = new Subject<any>();
  public organizationChanged$ = this._organizationChanged.asObservable();

  headerTitle$ = this._headerTitle.asObservable();

  settingoption$ = this._settingoption.asObservable();

  country$ = this._country.asObservable();
  org$ = this._org.asObservable();
  orgName$ = this._orgName.asObservable();
  orgNum$ = this._orgNum.asObservable();
  multiFeeFlagForPartner$ = this._multiFeeFlagForPartner.asObservable();
  changeOrg$ = this.changeOrg.asObservable();
  multiFee$ = this._multiFee.asObservable();

  object$ = this._object.asObservable();
  orgNameForCustomeFilter$ = this._orgNameForCustomeFilter.asObservable();
  orgCodeForCustomFilter$ = this._orgCodeForCustomFilter.asObservable();
  hamburger$ = this._hamburger.asObservable();

  showDetails$ = this._showDetails.asObservable();
  orgHeadingFromNavbar: string;
  setPageId$ = this._setPageId.asObservable();
  showNSPPrinciple$ = this._showNSPPrinciple.asObservable();

  constructor() {}

  setSelectedCountry(country: string) {
    this.selectedCountry = country;
  }
  getSelectedCountry() {
    return this.selectedCountry;
  }

  setHeaderTitle(title: string) {
    this._headerTitle.next(title);
  }

  settingoption(option: boolean) {
    this._settingoption.next(option);
  }
  setshowNSPPrinciple(value: boolean) {
    this._showNSPPrinciple.next(value);
  }

  showHamburger(status: boolean) {
    this._hamburger.next(status);
  }

  showDetail(flag: boolean) {
    this._showDetails.next(flag);
  }

  setCountry(country: string, multiFee: string, nspSplitFlag?: string) {
    this.nspFlagAdmin = nspSplitFlag;
    this._country.next(country);
    this._multiFee.next(multiFee);
  }
  getNspFlag(user: any) {
    //  if( user === "admin" ){
    return this.nspFlagAdmin;
    //  }
  }
  setOrgnization(multiFeeFlagForPartner: any, org: string, orgName: any, orgNum: any) {
    // Create the organization data array
    const orgData = [multiFeeFlagForPartner, org, orgName, orgNum];

    // Only emit the orgNum$ event, which will trigger all necessary updates
    this._orgNum.next(orgData);
  }

  // NEW: Method to get current organization without subscribing
  getCurrentOrganization(): any {
    return this._currentOrganization.value;
  }

  // NEW: Method to set organization with just the essential data
  setCurrentOrganization(orgData: any) {
    this._currentOrganization.next(orgData);
    this._organizationChanged.next(orgData);
  }

  setOrgnizationForCustomeFilter(orgNameForCustomeFilter: any, orgCodeForCustomFilter: any) {
    this._orgNameForCustomeFilter.next(orgNameForCustomeFilter);
    this._orgCodeForCustomFilter.next(orgCodeForCustomFilter);
  }
  setId(setPageId: any) {
    this._setPageId.next(setPageId);
  }
  setContBuss(contBuss: any) {
    this._object.next(contBuss);
  }

  setContries(val: any) {
    this.contriesList = val;
  }

  getContries() {
    return this.contriesList;
  }
  setOrgHeadingFromNavbar(org: any) {
    this.orgHeadingFromNavbar = org;
  }
  getOrgHeadingFromNavbar() {
    if (this.orgHeadingFromNavbar == '') {
      return false;
    } else {
      return true;
    }
  }

  removeOrgAfterUserRemove(orgName: any) {
    this.changeOrg.next(orgName);
  }
}
